var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{ref:"content",class:("cm-documentation__content-text cm-documentation__content-text--" + (_vm.data.class || 'default')),domProps:{"innerHTML":_vm._s(_vm.data.content)}})}
var staticRenderFns = []

export { render, staticRenderFns }